// extracted by mini-css-extract-plugin
export var buttonContainer = "cF_fp";
export var innerContainer = "cF_fz";
export var subtitle = "cF_k";
export var textContainer = "cF_dD";